'use client';

import { Button, ButtonGroup, PageHeader, TextLink } from '@petsmart-ui/sparky';

import { NAVIGATION_URLS } from '@libs/core';

import { PICTURES, SUPPORT_PHONE_NUMBER } from '../../constants';
import { ResponsivePicture } from '../ResponsivePicture';

const className = 'error-not-found';
const styles = `
        .error-not-found {
            margin-left: 16px;
            margin-right: 16px;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
        }

        .error-not-found__picture {
            display: block;
            margin: auto;
            max-width: 250px;
            min-height: 250px;
        }

        .error-not-found__header {
            margin-bottom: 16px;
        }

        .error-not-found__header .sparky-c-page-header__title {
            font-size: 36px;
            line-height: 44px;
        }

        .error-not-found__header .sparky-c-page-header__description {
            margin-top: 16px;
        }

        .error-not-found__button {
            width: 100%;
        }

        .terms-note {
            font-size: 0.8rem;
            text-align: center;
            margin: 1rem;
            font-family: proximanovaa-regular, sans-serif;
        }

        @media (min-width: 560px) {
            .error-not-found {
                margin-left: 32px;
                margin-right: 32px;
            }

            .error-not-found__text {
                max-width: 370px;
            }

            .error-not-found__picture {
                max-width: 350px;
                min-height: 350px;
            }

            .error-not-found__header .sparky-c-page-header__description {
                font-size: 20px;
                line-height: 28px;
            }
        }

        @media (min-width: 960px) {
            .error-not-found {
                margin: auto;
            }

            .error-not-found__text {
                max-width: 410px;
            }

            .error-not-found__picture {
                max-width: 400px;
                min-height: 400px;
            }

            .error-not-found__header .sparky-c-page-header__title {
                font-size: 40px;
                line-height: 48px;
            }

            .error-not-found__button {
                width: auto;
                padding: 14px 24px;
            }
        }
    `;

export const TermsNote = () => {
    return (
        <div className="terms-note">
            *Terms apply. Pricing, promotions and availability may vary by location and at PetSmart.com.
        </div>
    );
};

export default function ErrorNotFound() {
    const description = (
        <div className="sparky-u-theme-typography-body-lg-bold sparky-u-theme-typography-heading-6">
            <div>Error 404.</div>
            <div className={`${className}__text`}>
                Even our best sniffers can’t find your page. Want help? Contact us at{' '}
                <TextLink bold href={`tel:${SUPPORT_PHONE_NUMBER.RAW}`} className="sparky-u-theme-typography-heading-6">
                    {SUPPORT_PHONE_NUMBER.FORMATTED}
                </TextLink>
                .
            </div>
        </div>
    );

    return (
        <div data-testid="error-not-found">
            <style>{styles}</style>
            <div className={`sparky-u-responsive-margin-top-32-32-64 ${className}`}>
                <PageHeader align="center" title="Oops!" description={description} className={`${className}__header`} />
                <ResponsivePicture
                    data-testid="404-picture"
                    src={PICTURES.NOT_FOUND.SRC}
                    alt={PICTURES.NOT_FOUND.ALT_TEXT}
                    className={`${className}__picture`}
                    priority="eager"
                    sizes={[
                        { width: 250, height: 250 },
                        { width: 350, height: 350 },
                        { width: 400, height: 400 },
                    ]}
                />
                <ButtonGroup align="center" className="sparky-u-margin-top-md">
                    <Button
                        className={`sparky-u-theme-typography-body-lg ${className}__button`}
                        variant="primary"
                        text="Continue Shopping"
                        data-testid="404-button"
                        href={NAVIGATION_URLS.legacy.base}
                    />
                </ButtonGroup>
                <TermsNote />
            </div>
        </div>
    );
}
